import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Cotizaciones from './pages/Cotizaciones';
import Generadores from './pages/Generadores';
import Proyectos from './pages/Proyectos';
import Login from './pages/Login';
import Clientes from './pages/Clientes';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cotizaciones" element={<Cotizaciones />} />
        <Route path="/generadores" element={<Generadores />} />
        <Route path="/proyectos" element={<Proyectos />} />
        <Route path="/clientes" element={<Clientes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
